"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.contentUpdatePublish = exports.contentUpdateAccessPermission = exports.contentUpdate = exports.contentSuccess = exports.contentSoftDelete = exports.contentSlides = exports.contentSendNotification = exports.contentSaveAsDraft = exports.contentRootNodeCreate = exports.contentRestoreDelete = exports.contentRestoreBulkDelete = exports.contentResetEditorlock = exports.contentResetEditorUnlock = exports.contentReset = exports.contentListSoftDelete = exports.contentFetchSoftDeleted = exports.contentError = exports.contentEditorUnlock = exports.contentEditorLock = exports.contentEditorGet = exports.contentDuplicate = exports.contentDelete = exports.contentCreate = exports.contentCheckValidName = exports.contentBulkHardDelete = exports.contentAddAccessPermission = exports.contentAccessPermissionList = void 0;
var _content = require("./content.constant");
// @flow

// common success
var contentSuccess = function contentSuccess(actionType, data) {
  return {
    type: _content.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.contentSuccess = contentSuccess;
var contentError = function contentError(actionType, error) {
  return {
    type: _content.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.contentError = contentError;
var contentCreate = function contentCreate(data) {
  return {
    type: _content.actionTypes.CREATE,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.contentCreate = contentCreate;
var contentUpdate = function contentUpdate(data) {
  return {
    type: _content.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.contentUpdate = contentUpdate;
var contentEditorLock = function contentEditorLock(data) {
  return {
    type: _content.actionTypes.EDITOR_LOCK,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.contentEditorLock = contentEditorLock;
var contentEditorUnlock = function contentEditorUnlock(data) {
  return {
    type: _content.actionTypes.EDITOR_UNLOCK,
    payload: data
  };
};
exports.contentEditorUnlock = contentEditorUnlock;
var contentResetEditorUnlock = function contentResetEditorUnlock(data) {
  return {
    type: _content.actionTypes.RESET_EDITOR_UNLOCK,
    payload: data
  };
};
exports.contentResetEditorUnlock = contentResetEditorUnlock;
var contentResetEditorlock = function contentResetEditorlock(data) {
  return {
    type: _content.actionTypes.RESET_EDITOR_LOCK,
    payload: data
  };
};
exports.contentResetEditorlock = contentResetEditorlock;
var contentEditorGet = function contentEditorGet(data) {
  return {
    type: _content.actionTypes.EDITOR,
    payload: data
  };
};

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
exports.contentEditorGet = contentEditorGet;
var contentUpdatePublish = function contentUpdatePublish(data) {
  return {
    type: _content.actionTypes.UPDATE_PUBLISH,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
exports.contentUpdatePublish = contentUpdatePublish;
var contentDelete = function contentDelete(data) {
  return {
    type: _content.actionTypes.DELETE,
    payload: data
  };
};

/**
 * add access permission
 * @param payload
 * @returns api response
 * @description this function used to add access permission data.
 */
exports.contentDelete = contentDelete;
var contentAddAccessPermission = function contentAddAccessPermission(data) {
  return {
    type: _content.actionTypes.ADD_ACCESS_PERMISSION,
    payload: data
  };
};

/**
 * update access permission
 * @param payload
 * @returns api response
 * @description this function used to update access permission data.
 */
exports.contentAddAccessPermission = contentAddAccessPermission;
var contentUpdateAccessPermission = function contentUpdateAccessPermission(data) {
  return {
    type: _content.actionTypes.UPDATE_ACCESS_PERMISSION,
    payload: data
  };
};

/**
 * list access permission
 * @param payload
 * @returns api response
 * @description this function used to list access permission data.
 */
exports.contentUpdateAccessPermission = contentUpdateAccessPermission;
var contentAccessPermissionList = function contentAccessPermissionList(data) {
  return {
    type: _content.actionTypes.LIST_ACCESS_PERMISSION,
    payload: data
  };
};

/**
 * check valid name
 * @param payload
 * @returns api response
 * @description this function used to check valid name.
 */
exports.contentAccessPermissionList = contentAccessPermissionList;
var contentCheckValidName = function contentCheckValidName(data) {
  return {
    type: _content.actionTypes.CHECK_VALID_CP_NAME,
    payload: data
  };
};

/**
 * content panel slides
 * @param payload
 * @returns api response
 * @description this function used to content panel slides.
 */
exports.contentCheckValidName = contentCheckValidName;
var contentSlides = function contentSlides(data) {
  return {
    type: _content.actionTypes.LIST_CP_SLIDES,
    payload: data
  };
};

/**
 * content panel duplicate
 * @param payload
 * @returns api response
 * @description this function used to content panel duplicate.
 */
exports.contentSlides = contentSlides;
var contentDuplicate = function contentDuplicate(data) {
  return {
    type: _content.actionTypes.DUPLICATE,
    payload: data
  };
};

/**
 * content panel send notification
 * @param payload
 * @returns api response
 * @description this function used to content panel send notification.
 */
exports.contentDuplicate = contentDuplicate;
var contentSendNotification = function contentSendNotification(data) {
  return {
    type: _content.actionTypes.SEND_NOTIFICATION,
    payload: data
  };
};

/**
 * content panel save as draft
 * @param payload
 * @returns api response
 * @description this function used to content panel save as draft.
 */
exports.contentSendNotification = contentSendNotification;
var contentSaveAsDraft = function contentSaveAsDraft(data) {
  return {
    type: _content.actionTypes.SAVE_AS_DRAFT,
    payload: data
  };
};

/**
 * create
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
exports.contentSaveAsDraft = contentSaveAsDraft;
var contentRootNodeCreate = function contentRootNodeCreate(data) {
  return {
    type: _content.actionTypes.CREATE_ROOT_NODE,
    payload: data
  };
};
exports.contentRootNodeCreate = contentRootNodeCreate;
var contentSoftDelete = function contentSoftDelete(data) {
  return {
    type: _content.actionTypes.SOFT_DELETE,
    payload: data
  };
};
exports.contentSoftDelete = contentSoftDelete;
var contentListSoftDelete = function contentListSoftDelete(data) {
  return {
    type: _content.actionTypes.LIST_SOFT_DELETE,
    payload: data
  };
};
exports.contentListSoftDelete = contentListSoftDelete;
var contentRestoreDelete = function contentRestoreDelete(data) {
  return {
    type: _content.actionTypes.SOFT_RESTORE,
    payload: data
  };
};
exports.contentRestoreDelete = contentRestoreDelete;
var contentRestoreBulkDelete = function contentRestoreBulkDelete(data) {
  return {
    type: _content.actionTypes.BULK_SOFT_RESTORE,
    payload: data
  };
};
exports.contentRestoreBulkDelete = contentRestoreBulkDelete;
var contentBulkHardDelete = function contentBulkHardDelete(data) {
  return {
    type: _content.actionTypes.BULK_HARD_DELTETE,
    payload: data
  };
};
exports.contentBulkHardDelete = contentBulkHardDelete;
var contentFetchSoftDeleted = function contentFetchSoftDeleted(data) {
  return {
    type: _content.actionTypes.FETCH_SOFT_DELETED,
    payload: data
  };
};

/**
 * reset
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.contentFetchSoftDeleted = contentFetchSoftDeleted;
var contentReset = function contentReset() {
  return {
    type: _content.actionTypes.RESET
  };
};
exports.contentReset = contentReset;